module.exports = __webpack_public_path__ + "static/chilli-oil-66f95dce6276d254c162a22e6a2146e0.jpg";